module.exports = __webpack_public_path__ + "static/media/lipton-icetea.11071fb7.jpg";